//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/Builder.js";
let d=[[[0,"Driver",1,0],[0,"DumpOutput",1,0],[0,"DumpToFileName",1,0],[0,"PrintoutTags",1,0]],[[["type"],"GetUiSetting",{R_:{state:''}},1,0],[["type","state"],"SetUiSetting",{},2,0],[["type"],"GetTrace",{R_:{state:''}},1,0],[["type","state"],"SetTrace",{},2,0]],[]];
SPLM.SIM.SimDebugBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.SimDebugBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIM.SimDebugBuilder.DriverType = Object.freeze({
    "Cse" : "Cse", "Mtd" : "Mtd"});

SPLM.SIM.SimDebugBuilder.UiType = Object.freeze({
    "DisplayMomEvent" : "DisplayMomEvent", "ShowPartAndTipJunctions" : "ShowPartAndTipJunctions", "GenerateSpinningTools" : "GenerateSpinningTools", "UseHybridGougeChecker" : "UseHybridGougeChecker", "UseMtbOldDialogs" : "UseMtbOldDialogs", "UseFastTicker" : "UseFastTicker", "PrintOutTraceSerialNumbers" : "PrintOutTraceSerialNumbers", "PerformanceDisplayDetail" : "PerformanceDisplayDetail", "PerformanceDisplayTime" : "PerformanceDisplayTime", "PerformanceIndentTime" : "PerformanceIndentTime", "PerformanceDisplayData" : "PerformanceDisplayData", "DctkWriteCollisionPairs" : "DctkWriteCollisionPairs"});

SPLM.SIM.SimDebugBuilder.TraceType = Object.freeze({
    "ButtonDown" : "ButtonDown", "Vcr" : "Vcr", "Ipw" : "Ipw", "Performance" : "Performance", "Collision" : "Collision", "Gouge" : "Gouge", "Highlighting" : "Highlighting", "Details" : "Details", "PositionalIsv" : "PositionalIsv", "SpinningNonSpinning" : "SpinningNonSpinning", "KinematicModel" : "KinematicModel", "Event" : "Event", "LineServer" : "LineServer", "Sync" : "Sync", "ToolPathPicking" : "ToolPathPicking", "CseMotionData" : "CseMotionData", "CseCallStack" : "CseCallStack", "CseToolEvents" : "CseToolEvents", "CseCheckSyntax" : "CseCheckSyntax", "ProcessForce" : "ProcessForce", "Findings" : "Findings"});

SPLM.SIM.SimDebugBuilder.OutputType = Object.freeze({
    "Syslog" : "Syslog", "ListingWindow" : "ListingWindow", "Autotest" : "Autotest", "ToFile" : "ToFile"});

SPLM.SIM.SimDebugBuilder.KinematicModelType = Object.freeze({
    "Main" : "Main", "Simulation" : "Simulation", "Driver" : "Driver"});

SPLM.SIM.SimDebugBuilder.PrintoutTagsOrPointersType = Object.freeze({
    "Boolean" : "Boolean", "Value" : "Value", "Name" : "Name"});

export default SPLM;